import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useDebouncedValue } from '@betty/toolkit/hooks';
import { Box, ScrollView, SearchInput } from '@betty/moonlight';
import { SearchProps } from './Search.types';
import MostSearched from './MostSearched/MostSearched';
import TopSlotProviders from './TopSlotProviders/TopSlotProviders';
import Results from './Results/Results';
import { useFocusEffect, useTransitionEnd } from '@betty/navigation';
import { TextInput } from 'react-native';
import { useDispatch } from '@betty/toolkit/state';
import { fetchPromotedContent } from '../../state';

function Search(props: SearchProps) {
  const searchRef = useRef<TextInput>(null);
  const [searchText, setSearchText] = useState('');
  const debouncedSearchText = useDebouncedValue(searchText);
  const transitionEnded = useTransitionEnd();
  const dispatch = useDispatch();

  useEffect(() => {
    if (transitionEnded) {
      searchRef.current?.focus();
    }
  }, [transitionEnded]);

  useFocusEffect(
    useCallback(() => {
      dispatch(fetchPromotedContent());
    }, [dispatch]),
  );

  return (
    <Box flex={1} {...props}>
      <SearchInput
        ref={searchRef}
        value={searchText}
        placeholderKey="find"
        placeholderNS="games"
        onChangeText={setSearchText}
        marginHorizontal="space-600"
        marginBottom="space-400"
      />
      {debouncedSearchText ? (
        <Results searchText={debouncedSearchText} />
      ) : (
        <ScrollView
          keyboardDismissMode="interactive"
          keyboardShouldPersistTaps="handled"
          contentContainerStyle={{
            gap: 'space-600',
            height: '100%',
          }}
        >
          <MostSearched paddingTop="space-200" />
          <TopSlotProviders />
        </ScrollView>
      )}
    </Box>
  );
}

export default memo(Search);
